import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getLocalStorageItem, setLocalStorageItem } from "../common/LocalStorageService";
import { addToCart, applyDiscountCode, deleteCartCourse, myCartList } from "../api/apiHandler";

export const fetchCartData = createAsyncThunk(
    "cart/fetchCartData",
    async (_, { rejectWithValue }) => {
        try {
            const response = await myCartList();
            if (response?.code === 200 || response?.code === 404) {
                setLocalStorageItem("cartData", response?.data);
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
);

export const addCourseToCart = createAsyncThunk(
    "cart/addToCart",
    async ({ payload }, { dispatch, rejectWithValue }) => {
        try {
            const response = await addToCart(payload);
            if (response?.code === 200) {
                await dispatch(fetchCartData());
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
);

export const removeFromCart = createAsyncThunk(
    "cart/removeFromCart",
    async ({ payload }, { dispatch, rejectWithValue }) => {
        try {
            const response = await deleteCartCourse(payload);
            if (response?.code === 200) {
                await dispatch(fetchCartData()); // Refresh cart data
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
);

export const addRemoveDiscountCode = createAsyncThunk(
    "cart/addRemoveDiscountCode",
    async ({ payload }, { dispatch, rejectWithValue }) => {
        try {
            const response = await applyDiscountCode(payload);
            if (response?.code === 200) {
                await dispatch(fetchCartData()); // Refresh cart data
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response);
        }
    }
);

const initialState = {
    loading: false,
    cartData: getLocalStorageItem("cartData", null),
    error: null,
    success: false,
};

const cartPaymentSlice = createSlice({
    name: "cart",
    initialState,

    reducers: {
        setCartData: (state, action) => {
            setLocalStorageItem("cartData", action.payload);
            state.loading = false;
            state.cartData = action.payload;
            state.error = null;
        },
        removeCartData: (state) => {
            localStorage.removeItem("cartData");
            state.loading = false;
            state.cartData = null;
            state.error = null;
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchCartData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCartData.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.cartData = payload.data;
                state.success = true
            })
            .addCase(fetchCartData.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.error.message;
            })
    }
});


export const { setCartData, removeCartData } = cartPaymentSlice.actions;

export default cartPaymentSlice.reducer;